module.exports = __webpack_public_path__ + "static/media/meeting-mode-icon.bb967063.svg";